enum WidgetType {
  BUBBLE = 'BUBBLE',
  SIDE_BAR = 'SIDE_BAR',
  STRIP = 'STRIP',
  SEMI_OPEN_CTA = 'SEMI_OPEN_CTA',
  OPEN_CTA = 'OPEN_CTA'
}

export default WidgetType;
